import { Card } from 'antd';

const AntCard = ({ title, style, content, actions }) => {

    return (

        <Card title={title} style={style} actions={actions}>

            {content}

        </Card>

    );
};
export default AntCard;
